var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ManageUsersClientService } from "../../../../services/manage/manage-users.service";
import { UserModel } from "../../../../models/manage/user.models";
import { DataType, SourceType } from "../../../../models/queries/queries.models";
import * as Enumerable from "linq";
import { BindingEngine } from "aurelia-binding";
import { Router } from "aurelia-router";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { NotifyPropertyChangedBase, Reflection } from "../../../../utilities/reflection";
import { GenesisRouterConstants } from "../../../../configuration/router.constants";
import { PermissionEntity } from "../../../../models/manage/permissions.models";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { UnitOfWorkObserver } from "../../../../utilities/unit-of-work-observer";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../constants/authentication/claims";
import { DialogServiceConstants } from "../../../../constants/basics/dialog.constants";
import { UserClientService } from "../../../../services/authentication/user-client.service";
import { computedFrom } from "aurelia-binding";
import { I18N } from 'aurelia-i18n';
var Users = /** @class */ (function (_super) {
    __extends(Users, _super);
    function Users(manageUsersService, notificationService, dialogClient, userClaimsService, router, userClientService, engine, i18N) {
        var _this = _super.call(this) || this;
        _this.manageUsersService = manageUsersService;
        _this.notificationService = notificationService;
        _this.dialogClient = dialogClient;
        _this.userClaimsService = userClaimsService;
        _this.router = router;
        _this.userClientService = userClientService;
        _this.engine = engine;
        _this.i18N = i18N;
        _this.isAnd = true;
        _this.page = 0;
        _this.pages = 1;
        _this.recordsPerPage = 10;
        _this.clientAssociationEnabled = true;
        _this.canAddUser = true;
        _this.canEditUser = true;
        _this.canDeleteUser = true;
        _this.canAccessPermissions = true;
        _this.subscriptions = [];
        _this.userColumns = [
            {
                sortOrder: 1,
                columnOrder: 1,
                name: "name",
                dataType: DataType.Default,
                title: _this.i18N.tr('name-text')
            }, {
                sortOrder: 2,
                columnOrder: 2,
                name: "departmentAndRole",
                dataType: DataType.Default,
                title: _this.i18N.tr('department-and-role-text')
            }
        ];
        _this.canAddUser = _this.userClaimsService.hasPermission(Claims.CanAddUsers);
        _this.canEditUser = _this.userClaimsService.hasPermission(Claims.CanUpdateUsers);
        _this.canDeleteUser = _this.userClaimsService.hasPermission(Claims.CanDeleteUsers);
        _this.canAccessPermissions = _this.userClaimsService.hasPermission(Claims.CanAccessPermissions);
        _this.branchId = _this.userClientService.currentUser.branchId;
        return _this;
    }
    Object.defineProperty(Users.prototype, "branchId", {
        get: function () {
            return this._branchId;
        },
        set: function (x) {
            this._branchId = x;
            this.userInEdit = null;
            if (this.userInEditUow) {
                this.userInEditUow.dispose();
                this.userInEditUow = null;
            }
            this.page = 0;
            this.pages = 1;
            this.isEditCreate = false;
            this.loadAllUsers();
        },
        enumerable: false,
        configurable: true
    });
    Users.prototype.unselectRows = function () {
        this.isEditCreate = false;
        if (this.dataGridUsers) {
            this.dataGridUsers.unselectAll();
        }
    };
    Users.prototype.goToPermissions = function () {
        this.router.navigateToRoute(GenesisRouterConstants.RouteNames.ManagePermissions, {
            type: PermissionEntity.User,
            id: this.userInEdit.userId,
            roleIds: Enumerable.from(this.userInEdit.roleUsers).where(function (x) { return x.role != null; }).select(function (x) { return x.role.roleId; }).toArray(),
            departmentIds: Enumerable.from(this.userInEdit.roleUsers).where(function (x) { return x.role != null; }).select(function (x) { return x.role.departmentId; }).toArray(),
            branchIds: Enumerable.from(this.userInEdit.roleUsers).where(function (x) { return x.role.department != null; }).select(function (x) { return x.role.department.branchId; }).toArray(),
            employeeIds: Enumerable.from(this.userInEdit.userId).select(function (x) { return x; }).toArray(),
            name: this.userInEdit.fullName
        });
    };
    Users.prototype.goToValidations = function () {
        this.router.navigateToRoute(GenesisRouterConstants.RouteNames.ManageValidations, {
            type: PermissionEntity.User,
            id: this.userInEdit.userId,
            name: this.userInEdit.fullName
        });
    };
    Object.defineProperty(Users.prototype, "onlyOneSelected", {
        get: function () {
            if (this.users && this.userInEdit && this.userInEdit.userId > 0) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Users.prototype, "hasPervious", {
        get: function () {
            return this.page > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Users.prototype, "hasNext", {
        get: function () {
            return this.page < this.pages - 1;
        },
        enumerable: false,
        configurable: true
    });
    Users.prototype.activate = function (params, navigationInstruction) {
        var _this = this;
        if ('clientAssociationEnabled' in navigationInstruction.settings) {
            this.clientAssociationEnabled = navigationInstruction.settings.clientAssociationEnabled;
        }
        this.subscriptions.push(this.engine.propertyObserver(this, "recordsPerPage")
            .subscribe(function (newValue, oldValue) {
            _this.loadAllUsers();
        }));
    };
    Users.prototype.editUser = function ($event) {
        var _this = this;
        if ($event && $event.detail && $event.detail.item) {
            var userId = $event.detail.item.id;
            this.manageUsersService.getUser(userId)
                .then(function (x) {
                _this.setUser(x.user);
            }, function (x) { return _this.setUser(new UserModel()); });
            this.isEditCreate = true;
        }
    };
    Users.prototype.setUser = function (user) {
        var _this = this;
        if ((this.userInEdit && user && this.userInEdit.userId != user.userId) || !this.userInEdit) {
            var oldUser_1 = this.userInEdit;
            this.userInEdit = user;
            if (this.userInEditUow) {
                this.userInEditUow.dispose();
            }
            this.userInEditUow = UnitOfWorkObserver.getTrackingInstance(this.engine, this.userInEdit, ["role"]);
            setTimeout(function () {
                if (_this.manageUsersVm) {
                    _this.manageUsersVm.userHasChanged(user, oldUser_1);
                }
            });
        }
    };
    Users.prototype.newUser = function () {
        this.setUser(new UserModel());
        this.isEditCreate = true;
        this.userInEdit.isActive = true;
        this.userInEdit.branchId = this.branchId;
    };
    Users.prototype.save = function () {
        var _this = this;
        this.canEditUser = false; // disabled the save button after clicked a save. 
        if (this.userInEditUow && this.userInEditUow.hasChanges()) {
            if (!this.clientId && this.hasClientRole) {
                this.canEditUser = true; // enabled the save button onces updated the value for the below to save again.
                this.notificationService.show(this.i18N.tr('client-association-must-be-selected-text') + "!", "", NotificationType.Error, 2000);
                return;
            }
            var changes = this.userInEditUow.getChanges();
            // validate the inputted password
            if (!this.manageUsersVm.isConfirmPasswordMatched) {
                this.canEditUser = true;
                this.notificationService.show("Invalid password", "Confirm password must match the Password field value", NotificationType.Error, 5000);
                return;
            }
            if (!this.manageUsersVm.validateUpdatedPassword) {
                this.canEditUser = true;
                this.notificationService.show("Invalid password", "Password entered is invalid. Please enter a different password, or try refreshing the page..", NotificationType.Error, 5000);
                return;
            }
            var requestData = {
                changes: changes,
                id: this.userInEdit.userId,
                clientId: this.clientId,
                newPassword: this.manageUsersVm.getUpdatedPassword
            };
            this.manageUsersService.save(requestData)
                .then(function (x) {
                _this.canEditUser = true; // enabled the save button onces its saved successfully.
                _this.notificationService.show(_this.i18N.tr('user-successfully-saved-text'), "", NotificationType.Success, 2000);
                var cleanup = function () {
                    _this.search();
                    _this.userInEdit = null;
                    _this.isEditCreate = false;
                    if (_this.userInEditUow) {
                        _this.userInEditUow.dispose();
                        _this.userInEditUow = null;
                    }
                };
                var currentUser = _this.userClientService.currentUser;
                if (_this.userClientService.currentUser.id == _this.userInEdit.userId) {
                    if (currentUser && _this.userInEdit.roleUsers.every(function (x) { return x.roleId != currentUser.roleId; })) {
                        location.reload();
                    }
                    else {
                        cleanup();
                    }
                }
                else {
                    cleanup();
                }
            }).catch(function (exception) {
                if (exception._content.key == "password-invalid") {
                    var meta = exception._content.meta;
                    var passwordInvalidMessage = "";
                    if (!meta.satisfiesMinimumLength) {
                        passwordInvalidMessage += "Password must be long at least ".concat(meta.userPasswordPolicy.minimumLength, " characters.\n");
                    }
                    if (!meta.satisfiesMinimumNumberOfDigits) {
                        passwordInvalidMessage += "Password must have at least ".concat(meta.userPasswordPolicy.minimumNumberOfDigits, " digits.\n");
                    }
                    if (!meta.satisfiesMinimumNumberSpecialCharacters) {
                        passwordInvalidMessage += "Password must have at least ".concat(meta.userPasswordPolicy.minimumNumberSpecialCharacters, " special characters.\n");
                    }
                    _this.notificationService.show("Invalid password", passwordInvalidMessage, NotificationType.Error, 5000);
                }
                else {
                    _this.notificationService.show(exception._content.details ? exception._content.details : _this.i18N.tr('user-cannot-be-saved-text'), "", NotificationType.Error, 5000);
                }
            });
        }
    };
    Users.prototype.showDelete = function () {
        this.dialogClient.show(DialogServiceConstants.URLs.DeleteModal, this);
    };
    Users.prototype.getUsers = function () {
        return this.users.source;
    };
    Users.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.manageUsersService.delete({
                userIds: [_this.userInEdit.userId]
            })
                .then(function (x) {
                _this.dialogClient.hide();
                _this.notificationService.show(_this.i18N.tr('successfully-deleted-text'), _this.i18N.tr('user-has-been-successfully-deleted-text'), NotificationType.Success);
                _this.search();
                resolve();
            }, function (x) {
                _this.notificationService.show(_this.i18N.tr('warning') + "!", _this.i18N.tr('user-cannot-be-deleted-in-use-text'), NotificationType.Warning);
                reject();
            });
        });
    };
    Users.prototype.onEnter = function ($event) {
        if ($event.detail && $event.detail.keyCode == 13) {
            this.search();
        }
    };
    Users.prototype.search = function () {
        this.userInEdit = null;
        this.page = 0;
        this.loadAllUsers();
        this.isEditCreate = false;
    };
    Users.prototype.next = function () {
        this.page = this.page + 1;
        this.loadAllUsers();
        this.isEditCreate = false;
    };
    Users.prototype.pervious = function () {
        this.page = this.page - 1;
        this.loadAllUsers();
        this.isEditCreate = false;
    };
    Users.prototype.cancel = function () {
        this.isEditCreate = false;
        this.userInEdit = null;
        if (this.dataGridUsers) {
            this.dataGridUsers.unselectAll();
        }
    };
    Users.prototype.deactivate = function () {
        this.subscriptions.forEach(function (x) {
            x.dispose();
        });
    };
    Users.prototype.loadAllUsers = function () {
        var _this = this;
        if (this.branchId) {
            this.manageUsersService.getAllUsers({
                branchId: this.branchId,
                searchText: this.searchText,
                isAnd: this.isAnd,
                page: this.page,
                recordsPerPage: this.recordsPerPage
            }).then(function (x) {
                _this.pages = x.pages ? x.pages : 1;
                _this.users = { source: x.users, sourceType: SourceType.Collection, columns: _this.userColumns };
            }, function (e) { });
        }
    };
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.page; })),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Users.prototype, "hasPervious", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.page; }), Reflection.getPropertyPath(function (x) { return x.pages; })),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Users.prototype, "hasNext", null);
    Users = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ManageUsersClientService,
            NotificationClientService,
            DialogClientService,
            UserClaimsService,
            Router,
            UserClientService,
            BindingEngine,
            I18N])
    ], Users);
    return Users;
}(NotifyPropertyChangedBase));
export { Users };
